// extracted by mini-css-extract-plugin
module.exports = {"qrCodeContainer":"styles_qrCodeContainer__nMV78","qrcode":"styles_qrcode__doq0I"};